/**
 * 记录本次登录方式（主线程单例），供 reporter 随企业上报发给公司后台。
 * - qr    = 扫码登录（auth.importLoginToken）
 * - phone = 手机号 + 验证码登录（auth.signIn）
 * 由对应登录卡片在登录发起时设置；两步验证等后续步骤不改变已记录的方式。
 */
export type LoginMethod = 'qr' | 'phone';

let method: LoginMethod | undefined;

export function setLoginMethod(m: LoginMethod) {
  method = m;
}

export function getLoginMethod(): LoginMethod | undefined {
  return method;
}
